// this is an autogenerated file from DesignSystem/AppsAssignConnection/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_AppsAssignConnection($patient_id: uuid!, $connection_id: uuid!) {
  insert_apps_connection_patients_one(
    object: { patient_id: $patient_id, connection_id: $connection_id }
  ) {
    id
  }
}

`